import { render, staticRenderFns } from "./displayCase.vue?vue&type=template&id=e367801c&scoped=true&"
import script from "./displayCase.vue?vue&type=script&lang=js&"
export * from "./displayCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e367801c",
  null
  
)

export default component.exports